// Maps between the individual client tab slugs and the family screen tab slugs
// so switching between individual/family views (or between members) keeps the
// user on the equivalent tab instead of resetting to the profile tab.
// Both directions derive from this single pair list so they cannot drift.
const TAB_PAIRS: ReadonlyArray<readonly [individual: string, family: string]> = [
  ['non-financial-data', 'profile'],
  ['financial-data', 'financial'],
  ['cashflows', 'cashflows'],
  ['document', 'documents'],
  ['meetings', 'meetings'],
];

const DEFAULT_INDIVIDUAL_TAB = 'non-financial-data';
const DEFAULT_FAMILY_TAB = 'profile';

const individualToFamily = new Map(TAB_PAIRS);
const familyToIndividual = new Map(TAB_PAIRS.map(([individual, family]) => [family, individual]));

export const familyTabForIndividual = (tab: string | undefined): string =>
  (tab && individualToFamily.get(tab)) || DEFAULT_FAMILY_TAB;

export const individualTabForFamily = (tab: string | undefined): string =>
  (tab && familyToIndividual.get(tab)) || DEFAULT_INDIVIDUAL_TAB;
